<!-- [팝업] 설문 참여 제한을 위한 대상 설문조사 검색 -->
<template>
  <b-modal
    v-model="showSurveyRestrictionSelect"
    cancel-variant="outline-secondary"
    centered
    ok-title="적용"
    cancel-title="취소"
    size="lg"
    title="설문조사 검색"
    no-close-on-esc
    no-close-on-backdrop
    @ok.prevent="submit()"
    @close.prevent="close()"
    @cancel.prevent="close()"
  >
    <b-row
      class="mt-25"
    >
      <b-col
        cols="12"
        md="10"
        class="d-flex align-items-center justify-content-center"
      >
        <b-form-input
          v-model="query.filterStr"
          class="el-def"
          placeholder="검색어를 입력하세요."
          @keyup.enter="refetchData()"
        />
      </b-col>
      <!-- Search -->
      <b-col
        cols="12"
        md="2"
        class="d-flex align-items-center justify-content-end"
      >
        <b-button
          variant="primary"
          class="btn-search"
          @click.prevent="refetchData()"
        >
          조회
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-table
        ref="refSurveyTable"
        primary-key="id"
        :items="fetchSurveys"
        :fields="tableColumns"
        :sort-by.sync="sortBy"
        :sort-desc.sync="isSortDesc"
        responsive
        sticky-header
        selectable
        select-mode="multi"
        class="position-relative"
        @row-selected="onRowSelectedSurvey"
        @row-dblclicked="onRowDblClickedSurvey"
      >
        <template #cell(startDate)="data">
          <span class="text-nowrap">
            {{ data.value | $dateFormatter('YYYY-MM-DD') }}
          </span>
        </template>
        <template #cell(endDate)="data">
          <span class="text-nowrap">
            {{ data.value | $dateFormatter('YYYY-MM-DD') }}
          </span>
        </template>
      </b-table>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-pagination
          v-model="currPage"
          :total-rows="totalRecords"
          limit="10"
          per-page="10"
          align="center"
        />
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import axios from '@axios'
import { ref, watch, onMounted } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { errorFormatter } from '@core/utils/filter'

export default {
  components: {
  },

  props: {
    showSurveyRestrictionSelect: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    onMounted(() => {
      // fetchCodes()
    })

    const toast = useToast()

    // Query Data
    const query = ref({
      filterStr: null,
    })
    // Query Data End.

    const surveySelectIds = ref([])

    // Main Table Config
    const refSurveyTable = ref(null)
    const sortBy = ref('liveInfoId')
    const isSortDesc = ref(true)
    const currPage = ref(1)
    const totalRecords = ref(0)
    const tableColumns = [
      {
        key: 'liveInfoId', label: 'ID', sortable: true, thStyle: { width: '15%' },
      },
      {
        key: 'title', label: '설문제목', sortable: true, thStyle: { width: '45%' },
      },
      {
        key: 'startDate', label: '설문시작일', sortable: true, thStyle: { width: '20%' },
      },
      {
        key: 'endDate', label: '설문종료일', sortable: true, thStyle: { width: '20%' },
      },
    ]
    const refetchData = () => {
      refSurveyTable.value.refresh()
    }
    watch([currPage], () => {
      refetchData()
    })
    const onRowSelectedSurvey = items => {
      if (items && items.length) {
        const selectIds = items.map(x => x.liveInfoId)

        surveySelectIds.value = [...new Set([...surveySelectIds.value, ...selectIds])] // 중복 제거 후 합침
      }
    }
    const onRowDblClickedSurvey = item => {
      if (item && !surveySelectIds.value.find(liveInfoId => liveInfoId === item.liveInfoId)) {
        surveySelectIds.value.push(item.liveInfoId)
      }
      submit()
    }
    // Main Table Config End.

    const fetchSurveys = (ctx, callback) => {
      axios.post('/fa/survey-restriction-target/search', {
        search: {
          filterStr: query.value.filterStr,
        },
        sort: {
          predicate: sortBy.value,
          reverse: isSortDesc.value,
        },
        pagination: {
          number: currPage.value,
        },
      })
        .then(rs => {
          const { items, totalRecord } = rs.data
          callback(items)
          totalRecords.value = totalRecord
        })
        .catch(error => {
          toast({
            component: ToastificationContent,
            props: {
              title: errorFormatter(error, '데이터 조회에 실패하였습니다.'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }

    const close = () => {
      emit('close', null)
    }

    const submit = () => {
      if (surveySelectIds.value.length === 0) {
        toast({
          component: ToastificationContent,
          props: {
            title: '대상 설문조사를 선택하세요',
            icon: 'AlertTriangleIcon',
            variant: 'warning',
          },
        })
        return
      }

      const returnData = [...surveySelectIds.value]
      surveySelectIds.value = []

      emit('close', returnData)
    }

    return {
      query,
      close,
      submit,
      refSurveyTable,
      sortBy,
      currPage,
      isSortDesc,
      totalRecords,
      tableColumns,
      refetchData,
      onRowSelectedSurvey,
      onRowDblClickedSurvey,
      fetchSurveys,
    }
  },
}
</script>
